"use client";

import Link from "next/link";
import Image from "next/image";
import { Button, buttonVariants } from "@/components/ui/button";
import {
  Field,
  FieldContent,
  FieldDescription,
  FieldLabel,
} from "@/components/ui/field";
import { Checkbox } from "@/components/ui/checkbox";
import { useState } from "react";

export default function SignupStartClientPage(props: {
  siteBaseURL?: string;
  commentaryOnly: boolean;
}) {
  const [agreedPrivacy, setAgreedPrivacy] = useState(false);
  const [agreedSCData, setAgreedSCData] = useState(false);

  return (
    <>
      <Image
        src={"/Signups.png"}
        alt="Roses 2026 Media Signups"
        height={250}
        width={250}
        className="self-center"
      />
      <p>
        Hello, and thank you for signing up to help with the media coverage of
        Roses 2026! It&apos;s going to be a great weekend of sport and
        we&apos;re so glad you&apos;re interested in helping us cover it all.
      </p>
      <p>
        We&apos;re going to need a few details from you. We promise it
        won&apos;t take long!
      </p>
      {props.commentaryOnly && (
        <div className="m-1 px-8 py-4 border-black border-2 rounded-lg">
          <p>
            You told us you&apos;re only interested in commentating on matches.
            If you also want to get involved with other aspects of our coverage,
            please go back to the previous page and select &quot;Sign Up&quot;.
          </p>
        </div>
      )}
      <p>
        If you need to change any of the details you provide, you can always
        come back to <strong>{props.siteBaseURL}</strong> and update them. You
        will also receive an email with a link to update your details.
      </p>
      {/* <div className="m-1 px-8 py-4 border-black border-2 rounded-lg">
        <h2 className="text-xl font-bold">Data Protection Statement</h2>
        <p>
          We take protection of your data extremely seriously. Your data will
          only be accessible to leaders of the student media groups at the
          universities of York and Lancaster who need it in their roles as part
          of planning Roses. It may also be shared with staff at the
          Students&apos; Unions on a strict need-to-know basis. Your data is
          stored securely and will be deleted at the end of the academic year.
          We may preserve some data in an anonymised form to help plan future
          events.
        </p>
        <p>
          If you have any questions or concerns about how your data is used,
          please contact <a href="mailto:roses@ystv.co.uk">roses@ystv.co.uk</a>.
        </p>
      </div> */}
      <div className="w-full max-w-md">
        <Field orientation="horizontal">
          <Checkbox
            id="agree-privacy"
            onCheckedChange={(c) =>
              setAgreedPrivacy(
                typeof c.valueOf() === "boolean"
                  ? (c.valueOf() as boolean)
                  : false,
              )
            }
          />
          <FieldContent>
            <FieldLabel htmlFor="agree-privacy">
              <p>
                I agree to my data being processed in line with the{" "}
                <Link
                  style={{ textDecoration: "underline" }}
                  href={"/privacy"}
                >
                  Roses Media privacy policy
                </Link>
              </p>
            </FieldLabel>
          </FieldContent>
        </Field>
      </div>
      <div className="w-full max-w-md">
        <Field orientation="horizontal">
          <Checkbox
            id="agree-special-category"
            onCheckedChange={(c) =>
              setAgreedSCData(
                typeof c.valueOf() === "boolean"
                  ? (c.valueOf() as boolean)
                  : false,
              )
            }
          />
          <FieldContent>
            <FieldLabel htmlFor="agree-special-category">
              <p>
                I agree to my special category data being processed in line with
                the{" "}
                <Link
                  style={{ textDecoration: "underline" }}
                  href={"/privacy"}
                >
                  Roses Media privacy policy
                </Link>
              </p>
            </FieldLabel>
            <FieldDescription>
              This includes Dietary and Accessability Requirements if applicable
            </FieldDescription>
          </FieldContent>
        </Field>
      </div>
      {agreedPrivacy && agreedSCData ? (
        <Link
          href={`/signup/step1${props.commentaryOnly ? "?commentaryOnly=true" : ""}`}
          className="w-full"
          aria-disabled={agreedPrivacy}
        >
          <Button
            className={`${buttonVariants({ variant: "signup", size: "xl" })}`}
          >
            Continue
          </Button>
        </Link>
      ) : (
        <Button
          className={`${buttonVariants({ variant: "signup", size: "xl" })}`}
          disabled
        >
          Continue
        </Button>
      )}
    </>
  );
}
